/** @format */

import * as React from 'react'
import { getDisplayName } from './getDisplayName'

const noop = () => false

export const fulfill = (task = noop, recall = noop) => Comp =>
  class extends React.Component {
    static displayName = `@fulfill(${getDisplayName(Comp)})`

    componentDidMount() {
      task(this.props)
    }

    componentDidUpdate(prevProps) {
      if (recall(prevProps, this.props)) task(this.props)
    }

    render() {
      return <Comp {...this.props} />
    }
  }
